import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarClock, faArrowRightLong } from "@fortawesome/pro-regular-svg-icons";
import { Link } from "react-router-dom";
import { FormattedDate, Avatar } from "../../../common";
import DashboardCatchUpDto from "../../../../types/dtos/dashboards/right-bar/catch-ups/DashboardCatchUpDto";
import AppRoutes from "../../../../routes/AppRoutes";

interface CatchUpListItemProps {
  catchUp: DashboardCatchUpDto;
}

const CatchUpListItem = ({ catchUp }: CatchUpListItemProps) => {
  const collabDocUrl = AppRoutes.collaborativeDocument.generateRoute(
    catchUp.answerSetGuidId,
    false,
    null
  );

  return (
    <Link
      to={collabDocUrl}
      className="to-do-list-item bg-white cursor-pointer rounded-md border border-gray-300 hover:drop-shadow-md block"
    >
      <div className="flex flex-row items-start gap-2 p-3 min-w-0">
        <div className="shrink-0 pl-1">
          <Avatar
            imageUrl={catchUp.participantProfilePic}
            userFullName={catchUp.participantFullName}
            userInitials={catchUp.participantInitials}
            size={10}
            initialsTextClassName="text-sm"
          />
        </div>
        <div className="flex-grow min-w-0">
          <div className="text-xs text-gray-500 truncate">
            {catchUp.participantFullName}
          </div>
          {catchUp.title ? (
            <div className="text-sm font-semibold text-primary truncate leading-snug">
              {catchUp.title}
            </div>
          ) : null}
          <div className="text-xs text-slate-400 mt-0.5 truncate">
            <FontAwesomeIcon icon={faCalendarClock} className="pr-1" />
            <FormattedDate
              date={catchUp.dateScheduled}
              displayMode="DATE-AND-TIME"
              useTwentyFourHourTimeFormat={true}
            />
          </div>
        </div>
        <div className="shrink-0 self-center text-gray-400">
          <FontAwesomeIcon icon={faArrowRightLong} size="sm" />
        </div>
      </div>
    </Link>
  );
};

export default CatchUpListItem;
